import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DxFormComponent } from 'devextreme-angular';
import { Constants } from 'src/app/app.constants';
import { AlertService } from 'src/app/core/alert.service';
import { AuthService } from 'src/app/core/auth.service';
import { Dialog, DialogService } from 'src/app/core/dialog.service';
import { LoadingService } from 'src/app/core/loading.service';
import { TranslatorService } from 'src/app/core/translator.service';
import { UtilityService } from 'src/app/core/utility.service';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { ValueLabel } from 'src/app/shared/base/base.models';
import { BaseService } from 'src/app/shared/base/base.service';
import { ConfigurationItem, DataSyncConfiguration, SyncItem, Object, FieldMapping, DataSyncConfigurationItemType, DataSyncFieldMappingIgnore, DataSyncSelectionConditionEnum, DataSyncObjectType } from '../data-sync.models';

@Component({
  selector: 'app-data-sync-form',
  templateUrl: './data-sync-form.component.html',
  styleUrls: ['./data-sync-form.component.scss']
})
export class DataSyncFormComponent extends BaseFormComponent implements OnInit {  
  @ViewChild('formObjectItem', { static: false }) formObjectItem: DxFormComponent;
  @ViewChild('formSyncItem', { static: false }) formSyncItem: DxFormComponent;
  @ViewChild('formConfigurationItem', { static: false }) formConfigurationItem: DxFormComponent;
  @ViewChild('formAssociatedItem', { static: false }) formAssociatedItem: DxFormComponent;

  public tabs: string[] = ['ITEMS'];
  public isConfigurationItemModalVisible: boolean = false;
  public isSyncItemModalVisible: boolean = false;
  public isObjectItemModalVisible: boolean = false;
  public isAssociatedItemModalVisible: boolean = false;

  public syncItemModel: SyncItem = new SyncItem();
  public associatedItemModel: SyncItem = new SyncItem();
  public configurationItemModal : ConfigurationItem = new ConfigurationItem();
  public objectItemModel : Object = new Object();
  public configTypes : ValueLabel[] = [];
  public selectionConditions : ValueLabel[] = [];
  public fieldMappingsIgnore : ValueLabel[] = [];
  public objectTypes : ValueLabel[] = [];

  public isObjectItemModalEdit: boolean = false;
  public isSyncItemModalEdit: boolean = false;
  public isConfigurationItemEdit: boolean = false;
  public isAssociatedItemEdit: boolean = false;
  public isAssociatedObject : boolean = false;

  constructor(    
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public translateService: TranslateService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService)
  }

  ngOnInit(): void {
    this.authorities.init('DATA_SYNC', 'DATA_SYNC', 'DATA_SYNC', 'DATA_SYNC');
    this.url = `${Constants.contextPath}/data-sync/configurations`;

    this.prepareLookupData();

    this.prepareFormData(new DataSyncConfiguration(), (response: DataSyncConfiguration) => {
      return this.modifyResponse(response);
    });
  }

  public prepareLookupData() {
    this.configTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(DataSyncConfigurationItemType, true), 'value', 'label', 'ENUMS.DATA_SYNC.CONFIG_TYPES.');
    this.objectTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(DataSyncObjectType, true), 'value', 'label', 'ENUMS.DATA_SYNC.OBJECT_TYPES.');
    this.fieldMappingsIgnore = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(DataSyncFieldMappingIgnore, true), 'value', 'label', 'ENUMS.DATA_SYNC.FIELD_MAPPINGS_IGNORE.');
    this.selectionConditions = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(DataSyncSelectionConditionEnum, true), 'value', 'label', 'ENUMS.DATA_SYNC.SELECTED_CONDITIONS.');
  }

  openConfigurationItem(item: ConfigurationItem){
    this.configurationItemModal = item;

    this.isConfigurationItemEdit = true;
    this.isConfigurationItemModalVisible = true;
  }

  deleteConfigurationItem(item: ConfigurationItem){
    let dialog = new Dialog('SHARED.DELETE_QUESTION', () => {
      this.formData?.configurationItems.splice(this.formData?.configurationItems.indexOf(item),1)
    });

    this.dialogService.show(dialog); 
  }

  closeConfigurationItemModal(){
    this.isConfigurationItemModalVisible = false;
  }

  saveConfigurationItem(){    
    if (this.formConfigurationItem.instance.validate() != null && !this.formConfigurationItem.instance.validate().isValid || this.configurationItemModal.syncItems == null) {
      this.alertService.error('SHARED.INVALID_FORM');
      return;
    }

    if(this.formData.configurationItems == null)
      this.formData.configurationItems = [];
    
    this.formData.configurationItems.push(this.configurationItemModal);
    
    this.closeConfigurationItemModal();  
  }

  updateConfigurationItem(){
    if (this.formConfigurationItem.instance.validate() != null && !this.formConfigurationItem.instance.validate().isValid) {
      this.alertService.error('SHARED.INVALID_FORM');
      return;
    } 
    
    this.closeConfigurationItemModal();
  }

  openSyncItemModal(item: SyncItem){
    this.formData?.configurationItems.forEach(conf => {
      if(conf.syncItems != null){
        conf.syncItems.forEach(s => {
          if(s.id === item.id)
            this.configurationItemModal = conf;
        })
      }
    })
    
    this.isSyncItemModalEdit = true;
    this.syncItemModel = item;
    this.isSyncItemModalVisible = true;
  }

  deleteSyncItemModal(item: SyncItem, isModal: boolean = false){
    let dialog = new Dialog('SHARED.DELETE_QUESTION', () => {            
      if(isModal) 
        this.configurationItemModal.syncItems.splice(this.configurationItemModal.syncItems.indexOf(item),1)
      else{
        let confItem: ConfigurationItem = this.formData?.configurationItems[this.formData?.configurationItems.findIndex(c => c.syncItems.findIndex(s=> s.id == item.id ) > -1 )];
        this.formData?.configurationItems[this.formData?.configurationItems.findIndex(c => c.id == confItem.id)].syncItems.splice( this.formData?.configurationItems[this.formData?.configurationItems.findIndex(c => c.id == confItem.id)].syncItems.indexOf(item),1);       
      }
    });
  
    this.dialogService.show(dialog);
  }

  updateSyncItem(){
    if (this.formSyncItem.instance.validate() != null && !this.formSyncItem.instance.validate().isValid) {
      this.alertService.error('SHARED.INVALID_FORM');
      return;
    }

    if(this.syncItemModel.id == null)
      this.configurationItemModal.syncItems[this.configurationItemModal.syncItems.findIndex(i=>i.fieldMappings[0].__KEY__ === this.syncItemModel.fieldMappings[0].__KEY__)] = this.syncItemModel;
    else
      this.configurationItemModal.syncItems[this.configurationItemModal.syncItems.findIndex(i=>i.id === this.syncItemModel.id)] = this.syncItemModel;    

    this.isSyncItemModalVisible = false;
  }

  saveSyncItem(){
    if (this.formSyncItem.instance.validate() != null && !this.formSyncItem.instance.validate().isValid) {
      this.alertService.error('SHARED.INVALID_FORM');
      return;
    }

    if(this.configurationItemModal.syncItems == null)
      this.configurationItemModal.syncItems = [];

    this.configurationItemModal.syncItems.push(this.syncItemModel);
    this.isSyncItemModalVisible = false;
  }

  updateAssociatedItem(){
    if (this.formAssociatedItem.instance.validate() != null && !this.formAssociatedItem.instance.validate().isValid) {
      this.alertService.error('SHARED.INVALID_FORM');
      return;
    }

    if(this.associatedItemModel.id == null)
      this.syncItemModel.associatedItems[this.syncItemModel.associatedItems.findIndex(a => a.fieldMappings[0].__KEY__ === this.associatedItemModel.fieldMappings[0].__KEY__)] = this.associatedItemModel;
    else
      this.syncItemModel.associatedItems[this.syncItemModel.associatedItems.findIndex(a => a.id === this.associatedItemModel.id)] = this.associatedItemModel;


    this.configurationItemModal.syncItems[this.configurationItemModal.syncItems.findIndex(i=>i.id === this.syncItemModel.id)] = this.syncItemModel;

    this.isAssociatedItemModalVisible = false;
  }

  saveAssociatedItem(){
    if (this.formAssociatedItem.instance.validate() != null && !this.formAssociatedItem.instance.validate().isValid) {
      this.alertService.error('SHARED.INVALID_FORM');
      return;
    }    

    if(this.configurationItemModal.syncItems == null)
      this.configurationItemModal.syncItems = [];

    if(this.syncItemModel.associatedItems == null)
      this.syncItemModel.associatedItems = [];

    this.syncItemModel.associatedItems.push(this.associatedItemModel);

    this.configurationItemModal.syncItems[this.configurationItemModal.syncItems.findIndex(s => s.id === this.syncItemModel.id)] = this.syncItemModel;
    this.isAssociatedItemModalVisible = false;
  }

  openObjectItemModal(item: Object, isAssociated: boolean = false){
    this.isAssociatedObject = isAssociated;
    
    this.objectItemModel = item;
    
    if(this.objectItemModel.associationFields == null)
      this.objectItemModel.associationFields = [];

    if(this.objectItemModel.selectConditions == null)
      this.objectItemModel.selectConditions = [];

    this.isObjectItemModalEdit = true;
    this.isObjectItemModalVisible = true;
  }
  
  deleteObjectItemModal(item: Object, isAssociated: boolean = false){
    let dialog = new Dialog('SHARED.DELETE_QUESTION', () => {
      if(isAssociated)
        this.associatedItemModel.objects.splice(this.associatedItemModel.objects.indexOf(item),1)
      else
        this.syncItemModel.objects.splice(this.syncItemModel.objects.indexOf(item),1)
    });
  
    this.dialogService.show(dialog); 
  }

  openAddConfigurationItemModal(){
    this.configurationItemModal = new ConfigurationItem();
    
    this.isConfigurationItemEdit = false;
    this.isConfigurationItemModalVisible = true;
  }

  openAddSyncItemModal(){
    this.syncItemModel = new SyncItem();    
    this.syncItemModel.fieldMappings = [];

    this.isSyncItemModalEdit = false;
    this.isSyncItemModalVisible = true;
  }

  openAddObjectItemModal(){
    this.objectItemModel = new Object();
    this.objectItemModel.selectConditions = [];
    this.objectItemModel.associationFields = [];

    this.isAssociatedObject = false;

    this.isObjectItemModalEdit = false;
    this.isObjectItemModalVisible = true;
  }

  
  openAddAssociatedObjectItemModal(){
    this.objectItemModel = new Object();
    this.objectItemModel.selectConditions = [];
    this.objectItemModel.associationFields = [];

    this.isAssociatedObject = true;

    this.isObjectItemModalEdit = false;
    this.isObjectItemModalVisible = true;
  }

  saveObjectItem(){
    if (this.formObjectItem.instance.validate() != null && !this.formObjectItem.instance.validate().isValid || this.objectItemModel.selectConditions == null || this.objectItemModel.selectConditions.length <= 0) {
      this.alertService.error('SHARED.INVALID_FORM');
      return;
    }    

    if(this.isAssociatedObject){
      if(this.associatedItemModel.objects == null)
        this.associatedItemModel.objects = [];
    
      this.associatedItemModel.objects.push(this.objectItemModel);
    }else{
      if(this.syncItemModel.objects == null)
        this.syncItemModel.objects = [];
    
      this.syncItemModel.objects.push(this.objectItemModel);
    }

    this.isObjectItemModalVisible = false;
  }

  updateObjectItem(){
    if (this.formObjectItem.instance.validate() != null && !this.formObjectItem.instance.validate().isValid || this.objectItemModel.selectConditions == null || this.objectItemModel.selectConditions.length <= 0) {
      this.alertService.error('SHARED.INVALID_FORM');
      return;
    }

    if(this.isAssociatedObject){
      if(this.objectItemModel.id == null)
        this.associatedItemModel.objects[this.associatedItemModel.objects.findIndex(i=>i.selectConditions[0].__KEY__  === this.objectItemModel.selectConditions[0].__KEY__)] = this.objectItemModel;
      else
        this.associatedItemModel.objects[this.associatedItemModel.objects.findIndex(i=>i.id === this.objectItemModel.id)] = this.objectItemModel;
    }
    else{
      if(this.objectItemModel.id == null)
        this.syncItemModel.objects[this.syncItemModel.objects.findIndex(i=>i.selectConditions[0].__KEY__ === this.objectItemModel.selectConditions[0].__KEY__)] = this.objectItemModel;
      else
        this.syncItemModel.objects[this.syncItemModel.objects.findIndex(i=>i.id === this.objectItemModel.id)] = this.objectItemModel;
    }

    this.isObjectItemModalVisible = false;
  }

  disabledSyncItemModal(): boolean{
    let conServer: boolean = false;
    let conClient: boolean = false;
    this.syncItemModel?.objects?.forEach(o =>  {      
      if(o.type == DataSyncObjectType[DataSyncObjectType.SERVER])
        conServer=true;
      if(o.type == DataSyncObjectType[DataSyncObjectType.CLIENT])
        conClient=true;
    });
    
    return !conServer || !conClient || this.syncItemModel?.fieldMappings?.length<=0;
  }

  disabledAssociatedItemModal(): boolean{
    let conServer: boolean = false;
    let conClient: boolean = false;
    this.associatedItemModel?.objects?.forEach(o =>  {      
      if(o.type == DataSyncObjectType[DataSyncObjectType.SERVER])
        conServer=true;
      if(o.type == DataSyncObjectType[DataSyncObjectType.CLIENT])
        conClient=true;
    });
    
    return !conServer || !conClient || this.associatedItemModel?.fieldMappings?.length<=0;
  }

  openAddAssociatedtItemModal(){
    this.associatedItemModel = new SyncItem();
    this.associatedItemModel.fieldMappings = [];

    this.isAssociatedObject = true;

    this.isAssociatedItemModalVisible = true;
    this.isAssociatedItemEdit = false;
  }

  openAssociatedItemModal(item: SyncItem){
    this.associatedItemModel = item;
    this.isAssociatedItemEdit = true;
    this.isAssociatedItemModalVisible = true;
  }

  deleteAssociatedItemModal(item: SyncItem){
    let dialog = new Dialog('SHARED.DELETE_QUESTION', () => {
      this.syncItemModel.associatedItems.splice(this.syncItemModel.associatedItems.indexOf(item),1)
    });

    this.dialogService.show(dialog); 
  }

  onToolbarConfigurationPreparing($event){
    if (this.authorities.create || this.authorities.update) {
      $event.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          hint: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
          text: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
          showText: 'inMenu',
          onClick: this.openAddConfigurationItemModal.bind(this)
        },
        locateInMenu: 'auto'
      });
    }
  }

  onToolbarSyncItemsPreparing($event){
    if (this.authorities.create || this.authorities.update) {
      $event.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          hint: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
          text: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
          showText: 'inMenu',
          onClick: this.openAddSyncItemModal.bind(this)
        },
        locateInMenu: 'auto'
      });
    }
  }

  onToolbarObjectsPreparing($event){
    if (this.authorities.create || this.authorities.update) {
      $event.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          hint: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
          text: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
          showText: 'inMenu',
          onClick: this.openAddObjectItemModal.bind(this)
        },
        locateInMenu: 'auto'
      });
    }
  }

  onToolbarAssociatedObjectsPreparing($event){
    if (this.authorities.create || this.authorities.update) {
      $event.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          hint: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
          text: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
          showText: 'inMenu',
          onClick: this.openAddAssociatedObjectItemModal.bind(this)
        },
        locateInMenu: 'auto'
      });
    }
  }

  onToolbarAssociatedItemsPreparing($event){
    if (this.authorities.create || this.authorities.update) {
      $event.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          hint: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
          text: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
          showText: 'inMenu',
          onClick: this.openAddAssociatedtItemModal.bind(this)
        },
        locateInMenu: 'auto'
      });
    }
  }

  getRowNumber(item:any, array: any[]) {
    return array.indexOf(item);    
  }

}
